import { render, staticRenderFns } from "./BookTextPage.vue?vue&type=template&id=5aaf3c6e&"
import script from "./BookTextPage.vue?vue&type=script&lang=js&"
export * from "./BookTextPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports